export const NUM_CLASS_SEATS = 12
export const AUTO_ASSIGN_SEAT_RETRY_ATTEMPTS = 15
export const MAX_SUBSCRIPTION_RECONNECTION_ATTEMPTS = 50;
export const MAX_SUBSCRIPTION_HEALTH_CHECK_FAILURES = 3;
export const MAX_SUBSCRIPTION_INITIAL_CONNECTION_ATTEMPTS = 15;
